import React, { useState } from "react";
import { Drawer, Button } from "antd";
import { useNavigate } from "react-router-dom";
import { useAuthenticator } from '@aws-amplify/ui-react';
import { MenuOutlined, LogoutOutlined } from "@ant-design/icons";
import {ReactComponent as Logo} from '../../Assets/SVG/Logo.svg';
import { useRecoilState } from "recoil"
import { allSitesAtom } from "../../Atoms/allSitesAtom"
import "./NavBar.css";
import _ from 'lodash'

const NavBar = ({ menu }) => {
  const [visible, setVisible] = useState(false);
  const [allSites, setAllSites] = useRecoilState(allSitesAtom)
  const navigate = useNavigate();
  const { user, signOut } = useAuthenticator((context) => [context.user]);

  return (
    <nav className={user && _.has(user,'signInUserSession') && _.has(user.signInUserSession,'idToken') && _.has(user.signInUserSession.idToken,'jwtToken')?"navbar":"navbarMargin"}>
      <Drawer

        // style={{width:300}}
        // maskStyle={{width:300}}
        // drawerStyle={{width:300}}
        headerStyle={{margin:0,padding:0}}
        closeIcon={<></>}
        bodyStyle={{margin:0,padding:0}}
        title=""
        placement="left"
        onClick={() => {
          setVisible(false)
        }}
        onClose={() => {
          setVisible(false)
        }}
        open={visible}
      > 
        {menu}
     </Drawer>
     <div style={{display: 'flex',alignContent:'center'}}>
        {user?<MenuOutlined
          className="menu"
          onClick={() => {
            setVisible(true)
          }}
        />:<></>}
        <Logo style={{cursor:'pointer',height:55}} className="logo" onClick={() => navigate("/") }/>
      </div>
      
      <span style={{flex: 1}} />
      <div style={{display: 'flex',alignContent:'center'}}>
      {user &&
          <LogoutOutlined
            className="logout"
            onClick={() => {
              navigate("/")
              setAllSites({})
              signOut();
            }}
          />
      }
      </div>
    </nav>
  );
};

export default NavBar;